export default {
  id: "fruto-sensibilizacion",
  type: "short_study",
  titleKey: "programs.fruto_sensibilizacion.title",
  descriptionKey: "programs.fruto_sensibilizacion.desc",
  modules: [
    {
      id: "sesion-unica",
      titleKey: "programs.fruto_sensibilizacion.mod1.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.fruto_sensibilizacion.mod1.les1.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.fruto_sensibilizacion.mod1.les1.intro",
            },
            {
              type: "text",
              textKey: "programs.fruto_sensibilizacion.mod1.les1.caso",
            },
            {
              type: "verse",
              reference: "Efesios 4:11-12",
              referenceKey: "programs.fruto_sensibilizacion.mod1.les1.reference1",
              textKey: "programs.fruto_sensibilizacion.mod1.les1.verse1",
            },
          ],
          questions: [
            {
              id: "les1-q1",
              type: "reflection",
              afterBlock: 0,
              promptKey: "programs.fruto_sensibilizacion.mod1.les1.q1",
            },
            {
              id: "les1-q2",
              type: "reflection",
              afterBlock: 1,
              promptKey: "programs.fruto_sensibilizacion.mod1.les1.q2",
            },
            {
              id: "les1-q3",
              type: "reflection",
              afterBlock: 2,
              promptKey: "programs.fruto_sensibilizacion.mod1.les1.q3",
            },
            {
              id: "les1-q4",
              type: "reflection",
              promptKey: "programs.fruto_sensibilizacion.mod1.les1.q4",
            },
            {
              id: "les1-q5",
              type: "reflection",
              promptKey: "programs.fruto_sensibilizacion.mod1.les1.q5",
            },
            {
              id: "les1-q6",
              type: "reflection",
              promptKey: "programs.fruto_sensibilizacion.mod1.les1.q6",
            },
            {
              id: "les1-q7-journal",
              type: "application",
              promptKey: "programs.fruto_sensibilizacion.mod1.les1.q7",
            },
          ],
        },
      ],
    },
  ],
};
